import { render, staticRenderFns } from "./CuentasCP.vue?vue&type=template&id=48797846&"
import script from "./CuentasCP.vue?vue&type=script&lang=js&"
export * from "./CuentasCP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports